import { render, staticRenderFns } from "./whitelist_page.vue?vue&type=template&id=485c2232&scoped=true"
import script from "./whitelist_page.vue?vue&type=script&lang=js"
export * from "./whitelist_page.vue?vue&type=script&lang=js"
import style0 from "./whitelist_page.vue?vue&type=style&index=0&id=485c2232&prod&scoped=true&lang=css"
import style1 from "./whitelist_page.vue?vue&type=style&index=1&id=485c2232&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485c2232",
  null
  
)

export default component.exports